var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiSparkleFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24.1 24.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n        stroke-width: 0px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 12.1,
    y1: -794.1,
    x2: 12.1,
    y2: -818.1,
    gradientTransform: "translate(0 -794.1) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0086b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e055e2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.3,4.9c-.1,0-.2-.2-.2-.4s0-.2.2-.3l2.8-1.2,1.1-2.8C19.3,0,19.5,0,19.6,0S19.8,0,19.9.2l1.2,2.8,2.8,1.2c.1,0,.2.2.2.3s0,.3-.2.4l-2.8,1.1-1.2,2.8c0,.1-.2.2-.3.2s-.3,0-.4-.2l-1.1-2.8-2.8-1.1ZM23.9,19.2c.1,0,.2.2.2.3s0,.3-.2.4l-2.8,1.1-1.2,2.8c0,.1-.2.2-.3.2s-.3,0-.4-.2l-1.1-2.8-2.8-1.1c-.1,0-.2-.2-.2-.4s0-.2.2-.3l2.8-1.2,1.1-2.8c0-.1.2-.2.4-.2s.2,0,.3.2l1.2,2.8,2.8,1.2ZM18.1,12c0,.5-.3.8-.7,1l-4.9,2.4-2.4,4.9c-.2.4-.6.6-1,.6s-.8-.2-1-.6l-2.4-4.9L.7,13c-.4-.2-.6-.6-.6-1s.2-.8.6-1l4.9-2.4,2.4-4.9c.4-.8,1.6-.8,2,0l2.4,4.9,4.9,2.4c.4.2.7.6.7,1h.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSparkleFilled);
export default __webpack_public_path__ + "static/media/ai_sparkle_filled.ed35de6603d4ef8644f070f6091680a7.svg";
export { ForwardRef as ReactComponent };